
import { Settings } from '@/services/resources'

function upperFirstLetter (word) {
  return word.substr(0, 1).toUpperCase() + word.substr(1)
}

/**
 * 将中划线格式，转为驼峰
 * eg: order-record => orderRecord
 * @param {*} str
 */
function convert (str) {
  return str.replace(/(-[^-]*)/g, ($1) => {
    return upperFirstLetter($1.substr(1))
  })
}

const Keys = [
  'order-record-status',
  'order-record-service-type',
  'express-out',
  'express-in',
  'express-in-log-status',
  'pay-order-status',
  'sn-import-history',
  'nfc-format-history',
  'receive-type',
  'service-type',
  'child-service-type',
  'test-result',
  'rejection-reason',
  'sn-delete-type',
  'sn-delete-status',
  'pmp-record-status',
  'faults',
  'test-result-parent-category',
  'abnormal-record-status',
  'test-result-child-category'
]

const state = {
  // 订单状态
  orderRecordStatus: [],
  // 受理类型
  orderRecordServiceType: [],
  // 出货快递
  expressOut: [],
  // 入货快递
  expressIn: [],
  // 快递单状态
  expressInLogStatus: [],
  // 支付订单状态
  payOrderStatus: [],
  // sn导入历史状态
  snImportHistory: [],
  nfcFormatHistory: [],
  receiveType: [], // 授理类型
  serviceType: [], // 服务类型
  childServiceType: [], // 二级服务类型
  testResultParentCategory: [], // 检测结果分类父级
  testResultChildCategory: [], // 检测结果分类子级
  testResult: [], // 检测结果
  rejectionReason: [], // 拒收原因
  snDeleteType: [], // SN删除历史类型
  snDeleteStatus: [], // SN删除历史状态
  pmpRecordStatus: [], // 返修工单状态
  faults: [], // 故障
  abnormalRecordStatus: [] // 异常件状态
}

const mutations = {
  receiveAll (state, data) {
    Keys.map((key) => {
      let _data = data[key]
      let targetKey = convert(key)
      _data && Object.keys(_data).forEach(key => {
        state[targetKey].push({ id: parseInt(key), name: _data[key] })
      })
    })
  }
}

const actions = {
  async getAllSettings ({ state, commit }) {
    let resp = await Settings.query()
    commit('receiveAll', resp.data)
  }
}

const getters = {}
Keys.map(key => {
  getters[convert(key)] = state => state[convert(key)]
})

export default {
  state,
  mutations,
  actions,
  getters
}
